import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import Tesseract from 'tesseract.js';

import { Events } from 'ionic-angular';

//Anfag Tesseract Teil
var t =  Tesseract;
//Ende Tesseract Teil

@Injectable()
export class HandwritingtonumberProvider {

  constructor(public http: Http, public myevents:Events) {
    console.log('Hello HandwritingtonumberProvider Provider');
  }

//Anfang Hauptteil Tesseract
  public recogniceCanvas(canvas: HTMLCanvasElement) {

    console.log('before recognice');

    t.recognize(canvas, {
      lang: 'deu',
      tessedit_char_whitelist: '0123456789'
    })

      .progress(message => console.log(message))
      .catch(err => console.error(err))
       //.then(result => console.log(result))
       .then(result => this.myevents.publish('ocrChanged', result.text))
      // .then(function (result) {
      //   console.log('recogniceCanvas: '+ result.text);
      //  this.myevents.publish('ocrChanged', result.text);
        
         
      // })
      .finally(resultOrError => console.log(resultOrError));

  }

}



// WEBPACK FOOTER //
// ./src/providers/handwritingtonumber/handwritingtonumber.ts